import { render, staticRenderFns } from "./Carreras.vue?vue&type=template&id=f922c5c0&"
import script from "./Carreras.vue?vue&type=script&lang=js&"
export * from "./Carreras.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports